import React from "react";
import Container from "./Container.jsx";

const heroImage = "content/images/hero-image.jpg";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <img
        src={heroImage}
        alt="Skyline"
        className="absolute inset-0 h-full w-full object-cover opacity-.4"
        fetchpriority="high"
        decoding="async"
        sizes="100vw"
      />
      <div className="absolute inset-0" aria-hidden="true" />
      <Container className="relative py-20 sm:py-28 lg:py-32">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-white drop-shadow-lg">
            Independent Advice And Resources For Global Investors In UK Property.
          </h1>
          <p className="mt-6 text-lg text-white max-w-xl drop-shadow">
            Tailored strategies, expert guidance, and exclusive resources. Helping you cut through the noise to achieve your investment goals.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#/enquire"
              className="min-h-[44px] inline-flex items-center justify-center w-full sm:w-auto rounded-2xl px-5 py-3 font-semibold bg-#003366 hover:bg-[#003366] text-white text-center"
            >
              Enquire now
            </a>
            <a
              href="#/retirement"
              className="min-h-[44px] inline-flex items-center justify-center w-full sm:w-auto rounded-2xl px-5 py-3 font-semibold bg-#003366 hover:bg-[#003366] text-white text-center"
            >
              Passive Income Calculator
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}
